import { COMPOSE_POST_MAX_TITLE_LENGTH } from './SocialApi'

// Composer URLs are built from this hardcoded allowlist — never from
// game-supplied URLs. Keep in sync with the host-side copies in
// client/components/catalog/H5AppViewer/h5api/handlers/H5SocialHandler.ts
// (canonical source is this file).

/**
 * X (Twitter) web intent. The tracked link goes in `url` so it stays out of
 * the 280-char text budget.
 */
export function buildXComposerUrl(text: string, link?: string): string {
  const params = new URLSearchParams({ text })
  if (link) params.set('url', link)
  return `https://x.com/intent/post?${params.toString()}`
}

/**
 * Reddit submit page. Title falls back to the first 300 chars of the text;
 * the tracked link is appended to the body.
 */
export function buildRedditComposerUrl(options: {
  text: string;
  link?: string;
  title?: string;
  subreddit?: string;
}): string {
  const { text, link, title, subreddit } = options
  const params = new URLSearchParams({
    title: title || text.slice(0, COMPOSE_POST_MAX_TITLE_LENGTH),
    text: link ? `${text}\n\n${link}` : text,
  })
  const base = subreddit
    ? `https://www.reddit.com/r/${subreddit}/submit`
    : 'https://www.reddit.com/submit'
  return `${base}?${params.toString()}`
}
